import Hero from '../components/Hero';
import FeaturedTools from '../components/FeaturedTools';
import ToolCategories from '../components/ToolCategories';
import LatestArticles from '../components/LatestArticles';
import ToolComparisons from '../components/ToolComparisons';
import BrowserToolsSection from '../components/BrowserToolsSection';
import AboutSection from '../components/AboutSection';
import WhySection from '../components/WhySection';
import SupportSection from '../components/SupportSection';
import InowebSection from '../components/InowebSection';
import AdUnit from '../components/AdUnit';
import Seo, { SEO } from '../components/Seo';
import HomeJsonLd from '../components/HomeJsonLd';

export default function Home() {
  return (
    <>
      <Seo {...SEO.home} />
      <HomeJsonLd />
      <Hero />
      <FeaturedTools />
      <ToolCategories />
      <LatestArticles />
      <ToolComparisons />
      <BrowserToolsSection />
      <div className="max-w-4xl mx-auto px-4 py-10">
        <AdUnit slot="3659288415" />
      </div>
      <AboutSection />
      <WhySection />
      <SupportSection />
      <InowebSection />
    </>
  );
}
